import PropTypes from "prop-types";
import React from "react";

const HtmlContainer = ({ content }) => (
  <div dangerouslySetInnerHTML={{ __html: content }} />
);

HtmlContainer.propTypes = {
  content: PropTypes.node
};

export default HtmlContainer;



// WEBPACK FOOTER //
// ./src/components/HtmlContainer.jsx